import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';

import { useNsTHelper } from 'src/utils/i18n';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { commonSlice } from 'src/store/commonPart/slice';
import { InfoIcon } from 'src/components/Icons/Info';
import styles from 'src/styles/common/_personalOrBusinessForBusinessModal.module.scss';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import {
  deCommonCurrentPartnerSelector,
  showPersonalOrBusinessForBusinessModalSelector,
} from 'src/store/commonPart/selector';

const Modal: FC = () => {
  const { t } = useTranslation();
  const ns = 'modals.personalOrBusinessForBusiness';
  const tHelper = useNsTHelper(ns);

  const { ContactEmail } = useSelector(deCommonCurrentPartnerSelector);

  const dispatch = useDispatch();

  const handleClose = () => dispatch(commonSlice.actions.hidePersonalOrBusinessForBusinessModal());

  return (
    <UiModal
      onlySuccessBtn
      onHide={handleClose}
      modalClassName={styles.modal}
      successBtnText={t('common.close')}
      header={
        <div className={styles.header}>
          <InfoIcon className={styles.icon} />
          {tHelper('header')}
        </div>
      }
    >
      <div>{tHelper('description')}</div>
      <div>{tHelper('info')}</div>
      <div className={styles.feedback}>
        <Trans i18nKey="feedback" ns={ns} values={{ email: ContactEmail }}>
          <UiInnerNotSPALink href={`mailto:${ContactEmail}`} className={styles.link}>
            1
          </UiInnerNotSPALink>
        </Trans>
      </div>
    </UiModal>
  );
};

export const PersonalOrBusinessForBusinessModal: FC = () => {
  const showModal = useSelector(showPersonalOrBusinessForBusinessModalSelector);

  return showModal ? <Modal /> : null;
};
